var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"throbber-overlay"},[_c('div',{staticClass:"loading",class:{
                        'full': _vm.display === 'full' || !_vm.display,
                        'toast': _vm.display === 'toast',
                        'inline': _vm.display === 'inline',
                    }},[_vm._m(0),_vm._v(" "),(_vm.message)?_c('span',{staticClass:"throbber-message",domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"throbber"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin"})])
}]

export { render, staticRenderFns }